import { VisualizationCard } from "~/modules/visualization/components/VisualizationCard";
import { ChartConfig } from "~/modules/charts/types";
import { NetFlowsChartProvider } from "./NetFlowsChartProvider";

// // // //

/**
 * NetFlowsChartRenderer
 * Renders a net flows chart for the configured assets and date range.
 */
export function NetFlowsChartRenderer(props: {
    title: string;
    description: string;
    config: ChartConfig;
}) {
    const { title, description, config } = props;

    return (
        <NetFlowsChartProvider
            title={title}
            description={description}
            config={config}
        >
            {({
                title,
                description,
                isLoading,
                isEmpty,
                chartEl,
                emptyEl,
                loadingEl,
                customControls,
            }) => (
                <VisualizationCard
                    title={title}
                    subtitle={description}
                    watermark={
                        isLoading ? "none" : !isEmpty ? "center-50pct" : "none"
                    }
                    wrapperClassNameOverride=""
                    colSpans={{
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                        xxl: 12,
                    }}
                    showTimestamp={false}
                    customControls={customControls}
                >
                    {isLoading && <>{loadingEl}</>}
                    {!isLoading && !isEmpty && <>{chartEl}</>}
                    {isEmpty && <>{emptyEl}</>}
                </VisualizationCard>
            )}
        </NetFlowsChartProvider>
    );
}
